import { useAuthentication } from '@modules/authentication/providers';
import { useMutation } from '@tanstack/react-query';
import { captureException } from '@sentry/nextjs';
// eslint-disable-next-line no-restricted-imports -- needed
import { setAutogeneratedPlaceIcon } from '../../creations/placeThumbnails/utils/placeThumbnailsHelper';

const useUploadAutoGeneratedPlaceIconMutation = (onSuccess?: () => void) => {
  const { user } = useAuthentication();
  const { mutate: uploadAutoGeneratedPlaceIcon, mutateAsync: uploadAutoGeneratedPlaceIconAsync } =
    useMutation({
      mutationFn: async ({
        autoGenIconImageUrl,
        placeId,
      }: {
        autoGenIconImageUrl: string;
        placeId: number;
      }) => {
        await setAutogeneratedPlaceIcon(placeId, autoGenIconImageUrl, false, user?.id, undefined);
      },
      retry: true,
      onSuccess,
      onError: (error) => {
        const errorObj =
          error instanceof Error
            ? error
            : new Error(
                'CreateYourPlace - Error occurred while uploading initial autogenerated icon for Your Place',
              );
        captureException(errorObj);
      },
    });

  return { uploadAutoGeneratedPlaceIcon, uploadAutoGeneratedPlaceIconAsync };
};

export default useUploadAutoGeneratedPlaceIconMutation;
